import styled from "@emotion/styled";
import React from "react";

type TSize = "xs" | "sm" | "md" | "lg" | "xl";

interface IPadderProps extends React.ComponentPropsWithRef<"div"> {
  size: TSize;
}

const theme = (size: TSize) => {
  switch (size) {
    case "xs":
      return 5;
    case "sm":
      return 10;
    case "md":
      return 15;
    case "lg":
      return 25;
    case "xl":
      return 30;
    default:
      return;
  }
};

const Padder = styled.div<IPadderProps>`
  padding-top: ${(props) => theme(props.size)}px;
  width: 100%;
`;

export default Padder;
